<template lang="pug">
.Unit(:class='Class')
  .title(v-once) {{cont.departmentName}}
    div.tl().point
    div.tr().point
    div.bl().point
    div.br().point
  ArrControl(v-if='controlState',:cont='EliminateControl[controList]',@Determine='Determine')
  component(:is='control',v-if='control',:cont='EliminateControl[controList]',@Determine='Determine',@next="Determine")
</template>
<script>
import { setTimeout } from "timers";
import doCase from "@/mixins/case/doCase";
import ArrControl from "@/components/doCase/doControl/ArrControl"; // 欢迎进入控件
import MATERIALANALYSISPROBLEM from "@/components/doCase/doControl/doSubject/MATERIALANALYSISPROBLEM"; // 欢迎进入控件
import DIALOGUE from "@/components/doCase/doControl/doCaseContent/DIALOGUE"; // 对话
import bus from "@/utils/main";

export default {
  props: ["cont"],
  mixins: [doCase],
  components: { ArrControl, MATERIALANALYSISPROBLEM, DIALOGUE },
  data() {
    return {
      Class: this.cont.scene,
      dialogueList: [],
      contState: 0,
      control: "",
      step: ["FORMULATE", "EXECUTE", "ASSESS", "FINALITY"],
      controlState: false,
      AssessmentState: false,
      HistoryData: [],
      sceneControlList: [],
      controList: 0,
      AssessmentIndex: -1, // 场景里的第几个控件
      EliminateControl: [] // 处理后的控件
    };
  },
  watch: {
    sceneControlList: {
      handler() {
        this.add();
        this.query();
      },
      deep: true
    }
  },
  methods: {
    query() {
      // 所有的caseHallId和tsId进行了翻转
      const data = {
        caseHallId: this.$store.state.doCase.caseData[
          this.step[+sessionStorage.getItem("doIndex")]
        ].tsId,
        classId: sessionStorage.getItem("classId"),
        experimentId: this.$store.state.doCase.experimentId,
        pyId: this.$store.state.doCase.caseId,
        tsId: this.cont
          ? this.cont.id
          : this.$store.state.doCase.caseData[
              this.step[+sessionStorage.getItem("doIndex")]
            ].tsId,
        userId: this.$role.code
      };
      this.$http.listStuControl(data).then(res => {
        console.log(res);
        // console.clear();
        if (Array.isArray(this.cont)) {
          this.cont.forEach((element, index) => {
            const find = value => {
              return value.controlId === element.id;
            };
            // console.log(this.cont.find(find));
            console.log(res.data.data);
            if (res.data.data) {
              if (res.data.data.find(find)) {
                this.HistoryData[index] = res.data.data.find(find);
              }
            }
          });
          this.content = this.cont;
        } else {
          this.HistoryData = res.data.data;
          console.log(res);
          bus.$emit("onesbChange", res.data.data[this.controList]);
        }
      });
    },
    Determine() {
      // 关闭
      if (this.EliminateControl.length > this.controList + 1) {
        this.control = false;
        this.controList += 1;
        setTimeout(() => {
          this.control = this.EliminateControl[this.controList].type;
        }, 300);
        setTimeout(() => {
          bus.$emit("onesbChange", this.HistoryData[this.controList]);
        }, 350);
        this.add();
      } else {
        this.$emit("SignOut");
      }
    },
    add() {
      const contList = [];
      let data = [];
      let num = 0;
      this.sceneControlList.forEach((element, index) => {
        if (num === +element.pageNumber) {
          if (this.AloneControl.indexOf(element.type) === -1) {
            data.push(element);
            if (index === this.sceneControlList.length - 1) {
              if (data.length !== 0) {
                contList.push(data);
              }
            }
          } else {
            if (data.length !== 0) {
              contList.push(data);
            }
            contList.push(element);
            data = [];
          }
        } else if (this.AloneControl.indexOf(element.type) === -1) {
          if (data.length !== 0) {
            contList.push(data);
          }
          data = [];
          data.push(element);
          if (index === this.sceneControlList.length - 1) {
            contList.push(data);
          }
        } else {
          if (data.length !== 0) {
            contList.push(data);
          }
          contList.push(element);
          data = [];
        }
        num = +element.pageNumber;
      });
      this.EliminateControl = contList;
      console.log();

      if (Array.isArray(this.EliminateControl[this.controList])) {
        this.controlState = true;
      } else {
        // 单种形式的题目
        console.log("单种形式的题目");
        console.log(this.EliminateControl);
        this.control = this.EliminateControl[this.controList].type;
      }
    }
  },
  created() {
    // mixins里的函数 处理sceneControlList；
    this.doCaseQueryControl();

    console.log(this.cont);
    console.log(this);
  }
};
</script>
<style lang="stylus" scoped>
.Unit
  position absolute
  // background url('../../../assets/case/department/myOffice.png')
  height 100vh
  width 100vw
  z-index 5
  .title
    position absolute
    top 76px
    left 0
    right 0
    margin 0 auto
    width 150px
    height 40px
    background-color rgba(245, 166, 35, 1)
    border-radius 4px
    opacity 0.8022
    font-size 18px
    font-family fzhpfw
    font-weight normal
    color rgba(255, 255, 255, 1)
    line-height 40px
    .point
      width 4px
      height 4px
      background rgba(255, 255, 255, 1)
      border-radius 2px
      opacity 0.3043
      &:nth-child(1)
        position absolute
        top 4px
        left 6px
      &:nth-child(2)
        position absolute
        top 4px
        right 6px
      &:nth-child(3)
        position absolute
        bottom 4px
        left 6px
      &:nth-child(4)
        position absolute
        bottom 4px
        right 6px
.UnitA
  background url('../../../assets/case/case5.png')
  background-size 100vw
.UnitB
  background url('../../../assets/case/case6.png')
  background-size 100vw
.UnitC
  background url('../../../assets/case/case7.png')
  background-size 100vw
.UnitD
  background url('../../../assets/case/case8.png')
  background-size 100vw
.UnitE
  background url('../../../assets/case/case9.png')
  background-size 100vw
.UnitF
  background url('../../../assets/case/case10.png')
  background-size 100vw
.UnitG
  background url('../../../assets/case/case11.png')
  background-size 100vw
.UnitH
  background url('../../../assets/case/case12.png')
  background-size 100vw
.UnitI
  background url('../../../assets/case/case13.png')
  background-size 100vw
.UnitJ
  background url('../../../assets/case/case14.png')
  background-size 100vw
.UnitK
  background url('../../../assets/case/case15.png')
  background-size 100vw
.UnitL
  background url('../../../assets/case/case16.png')
  background-size 100vw
.UnitM
  background url('../../../assets/case/case17.png')
  background-size 100vw
.UnitN
  background url('../../../assets/case/case18.png')
  background-size 100vw
.UnitO
  background url('../../../assets/case/case19.png')
  background-size 100vw
.UnitP
  background url('../../../assets/case/case20.png')
  background-size 100vw
.UnitQ
  background url('../../../assets/case/case21.png')
  background-size 100vw
</style>
